<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-row>
        <el-col :span="16">
          <el-button
            type="primary"
            v-role="['3']"
            class="add"
            size="small"
            @click="addMatch"
          >
            <i class="el-icon-plus"></i>
            发布比赛
          </el-button>
          <el-button
            type="primary"
            class="add"
            size="small"
            v-role="['1']"
            @click="addAdminMatch"
          >
            <i class="el-icon-plus"></i>
            发布比赛
          </el-button>
          <el-button
            type="danger"
            v-role="['1', '3']"
            size="small"
            class="delete"
            @click="delMulData"
          >
            <i class="el-icon-delete"></i>删除
          </el-button>

          <el-button
            type="success"
            v-role="['1']"
            size="small"
            class="success"
            @click="authHost"
          >
            <i class="el-icon-delete"></i>授权主办方
          </el-button>
        </el-col>
        <el-col :span="8" style="text-align: right">
          <el-button
            type="success"
            v-role="['2']"
            size="small"
            @click="joinNewMatch"
          >
            <i class="el-icon-delete"></i>参加新的比赛
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入比赛名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="search"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="比赛名称"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link
            v-if="isHostOrAdmin()"
            :href="'/#/playerchartset?matchId=' + scope.row.matchId"
            type="success" class="match-title"
            > <div class="wrap-text" @click="gotoChart(scope.row.matchId)">
            {{ scope.row.name!=null?scope.row.name.replaceAll('\\n','\n'):""}}</div>
           </el-link
          >
          <div class="wrap-text cell" v-else @click="gotoChart(scope.row.matchId)">
            {{ scope.row.name!=null?scope.row.name.replaceAll('\\n','\n'):""}}</div>
         
        </template>
      </el-table-column>
     
      <el-table-column
        prop="guidOrganizer"
        align="center"
        label="指导单位"
      >
      <template slot-scope="scope">
      <div class="wrap-text">{{ scope.row.guidOrganizer!=null?scope.row.guidOrganizer.replaceAll('\\n','\n'):"" }}</div>
    </template>
  </el-table-column>
      <el-table-column
        prop="supportOrganizer"
        align="center"
        label="支持单位"
      >
      <template slot-scope="scope">
      <div class="wrap-text">{{  scope.row.supportOrganizer!=null?scope.row.supportOrganizer.replaceAll('\\n','\n'):""}}</div>
    </template>
    </el-table-column>
      <el-table-column
        prop="host"
        align="center"
        label="主办单位"
      >
      <template slot-scope="scope">
      <div class="wrap-text">{{ scope.row.host!=null?scope.row.host.replaceAll('\\n','\n'):""}}</div>
    </template>

    </el-table-column>
      <el-table-column
        prop="organizer"
        align="center"
        label="承办单位"
      >
      <template slot-scope="scope">
      <div class="wrap-text">{{ scope.row.organizer!=null?scope.row.organizer.replaceAll('\\n','\n'):""}}</div>
    </template>

    </el-table-column>
     <el-table-column
        prop="confirmOrganizer"
        align="center"
        label="执行单位"
      ><template slot-scope="scope">
      <div class="wrap-text">{{scope.row.confirmOrganizer!=null?scope.row.confirmOrganizer.replaceAll('\\n','\n'):"" }}</div>
    </template>
  </el-table-column>
      <el-table-column
        prop="coOrganizer"
        align="center"
        label="协办单位"
      >
      <template slot-scope="scope">
      <div class="wrap-text">{{ scope.row.coOrganizer!=null?scope.row.coOrganizer.replaceAll('\\n','\n'):""}}</div>
    </template>

    </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        label="地址"
      >
       <template slot-scope="scope">
      <div class="wrap-text">{{ scope.row.address!=null?scope.row.address.replaceAll('\\n','\n'):""}}</div>
    </template>

  </el-table-column>
      <el-table-column
        prop="inviteCode"
        align="center"
        label="邀请码"
      ></el-table-column>
      <el-table-column
        prop="startTime"
        align="center"
        label="比赛日期"
        :formatter="startTimeFormatter"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="180"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              v-role="['1', '3']"
              @click="deleteMatch(scope.row)"
              class="btnopt"
              size="small"
              >删除</el-button
            >
            <el-button
              type="text"
              v-role="['1', '3']"
              size="small"
              @click="editMatch(scope.row)"
              class="btnopt"
              >编辑</el-button
            >

            <el-button
              type="text"
              size="small"
              @click="gotoMatch(scope.row)"
              class="btnopt"
              >进入比赛</el-button
            >
          </div>
          <div>
            <el-button
              type="text"
              size="small"
              @click="showUploadDialog(scope.row.matchId)"
              v-if="isHostOrAdmin()"
              class="btnopt"
              >上传</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="showDownloadDialog(scope.row.matchId, 1)"
              class="btnopt"
              >规程</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="showDownloadDialog(scope.row.matchId, 2)"
              class="btnopt"
              >组别</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[1, 5, 15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'发布比赛'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="比赛名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        
        <el-form-item label="指导单位" prop="guidOrganizer">
          <el-input v-model="form.guidOrganizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="支持单位" prop="supportOrganizer">
          <el-input v-model="form.supportOrganizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="主办单位" prop="host">
          <el-input v-model="form.host" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="hostMobile">
          <el-input v-model="form.hostMobile" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="承办单位" prop="organizer">
          <el-input v-model="form.organizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="执行单位" prop="confirmOrganizer">
          <el-input v-model="form.confirmOrganizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="协办单位" prop="coOrganizer">
          <el-input v-model="form.coOrganizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="比赛时间" prop="dateRange">
          <el-date-picker
            v-model="form.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报名截止日期" prop="registrationEndTime">
          <el-date-picker
            v-model="form.registrationEndTime"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份验证">
          <el-radio-group v-model="form.isIdentityValidate">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="身份证必填">
          <el-radio-group v-model="form.isNeedIdentity">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="主办方返点">
          <el-radio-group v-model="form.isShowRebate">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">显示</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="代表队返点">
          <el-radio-group v-model="form.isShowTeamRebate">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">显示</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="比赛地点" prop="address">
          <el-input v-model="form.address" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="竞赛规程" prop="competitionRules">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入竞赛规程"
            v-model="form.competitionRules"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="封面图" prop="coverImage">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            accept="image/png,image/gif,image/jpg,image/jpeg"
            :limit="1"
            :http-request="uploadEditFile"
          >
            <img v-if="form.coverImage" :src="form.coverImage" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="'编辑比赛'"
      :inline="true" 
      :visible.sync="dialogEditFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-tabs type="border-card">
          <el-tab-pane label="比赛信息">
            <el-form-item label="比赛名称" prop="name">
              <el-input v-model="form.name" maxlength="255"></el-input>
            </el-form-item>
           
            <el-form-item label="指导单位" prop="guidOrganizer">
              <el-input v-model="form.guidOrganizer" maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="支持单位" prop="supportOrganizer">
              <el-input
                v-model="form.supportOrganizer"
                maxlength="255"
              ></el-input>
            </el-form-item>
            <el-form-item label="主办单位" prop="host">
              <el-input v-model="form.host" maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="hostMobile">
              <el-input v-model="form.hostMobile" maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="承办单位" prop="organizer">
              <el-input v-model="form.organizer" maxlength="255"></el-input>
            </el-form-item>
             <el-form-item label="执行单位" prop="confirmOrganizer">
              <el-input
                v-model="form.confirmOrganizer"
                maxlength="255"
              ></el-input>
            </el-form-item>
            <el-form-item label="协办单位" prop="coOrganizer">
              <el-input v-model="form.coOrganizer" maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="比赛时间" prop="dateRange">
              <el-date-picker
                v-model="form.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="报名截止日期" prop="registrationEndTime">
              <el-date-picker
                v-model="form.registrationEndTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="身份验证">
              <el-radio-group v-model="form.isIdentityValidate">
                <el-radio :label="false">禁用</el-radio>
                <el-radio :label="true">启用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="身份证必填">
              <el-radio-group v-model="form.isNeedIdentity">
                <el-radio :label="false">禁用</el-radio>
                <el-radio :label="true">启用</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="主办方返点">
              <el-radio-group v-model="form.isShowRebate">
                <el-radio :label="false">关闭</el-radio>
                <el-radio :label="true">显示</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="代表队返点">
              <el-radio-group v-model="form.isShowTeamRebate">
                <el-radio :label="false">关闭</el-radio>
                <el-radio :label="true">显示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="下载模式" prop="coOrganizer">
              <el-select v-model="form.exportMode" placeholder="请选择">
                <el-option label="普通模式" :value="1"> </el-option>
                <el-option label="附带代表队信息" :value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="比赛地点" prop="address">
              <el-input v-model="form.address" maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="竞赛规程" prop="competitionRules">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入竞赛规程"
                v-model="form.competitionRules"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="封面图" prop="coverImage">
              <el-upload
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :limit="1"
                :http-request="uploadEditFile"
              >
                <img
                  v-if="form.coverImage"
                  :src="form.coverImage"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="音乐设置">
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item
                v-for="(item, index) in categories"
                :title="item.name"
                :name="item.name"
                :key="index"
              >
                <template slot="title">
                  {{ item.name }}
                  <el-button
                    type="danger"
                    style="margin-left: 10px"
                    title="删除分类"
                    icon="el-icon-delete"
                    size="mini"
                    @click="deleteCategories(item.id)"
                  ></el-button>
                </template>
                <div
                  style="padding: 5px; margin: 5px"
                  v-for="(music, mindex) in item.matchMusics"
                  :key="mindex"
                >
                  <el-tag closable @close="deleteMusic(music.id)">
                    {{ music.name }}</el-tag
                  >
                </div>

                <el-upload
                  class="upload-demo"
                  drag v-if="dialogEditFormVisible" 
                  accept=".mp3,.wav,.aac,.flac,.ogg,.wma,.m4a"
                  :http-request="
                    (file) => uploadMusicFile(file, form.matchId, item.id)
                  "
                  multiple
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    只能上传mp3/wav文件
                  </div>
                </el-upload>
              </el-collapse-item>
            </el-collapse>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ 音乐分类</el-button
            >
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEditForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="'发布比赛'"
      :inline="true"
      :visible.sync="dialogAdminFormVisible"
    >
      <el-form
        :model="adminform"
        label-position="right"
        label-width="110px"
        :rules="adminFormRules"
        ref="adminform"
      >
        <el-form-item label="主办方" prop="competitionHostId">
          <el-select v-model="adminform.competitionHostId">
            <el-option
              v-for="item in hostOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛名称" prop="name">
          <el-input v-model="adminform.name" maxlength="255"></el-input>
        </el-form-item>        
        <el-form-item label="指导单位" prop="guidOrganizer">
          <el-input
            v-model="adminform.guidOrganizer"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="支持单位" prop="supportOrganizer">
          <el-input
            v-model="adminform.supportOrganizer"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="主办单位" prop="host">
          <el-input v-model="adminform.host" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="hostMobile">
          <el-input v-model="adminform.hostMobile" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="承办单位" prop="organizer">
          <el-input v-model="adminform.organizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="执行单位" prop="confirmOrganizer">
          <el-input
            v-model="adminform.confirmOrganizer"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="协办单位" prop="coOrganizer">
          <el-input v-model="adminform.coOrganizer" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="比赛时间" prop="dateRange">
          <el-date-picker
            v-model="adminform.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报名截止日期" prop="registrationEndTime">
          <el-date-picker
            v-model="adminform.registrationEndTime"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份验证">
          <el-radio-group v-model="adminform.isIdentityValidate">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="身份证必填">
          <el-radio-group v-model="form.isNeedIdentity">
            <el-radio :label="false">禁用</el-radio>
            <el-radio :label="true">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="主办方返点">
          <el-radio-group v-model="adminform.isShowRebate">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">显示</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="代表队返点">
          <el-radio-group v-model="adminform.isShowTeamRebate">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面图" prop="coverImage">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            accept="image/png,image/gif,image/jpg,image/jpeg"
            :limit="1"
            :http-request="uploadAdminEditFile"
          >
            <img
              v-if="adminform.coverImage"
              :src="adminform.coverImage"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="下载模式" prop="coOrganizer">
          <el-select v-model="adminform.exportMode" placeholder="请选择">
            <el-option label="普通模式" :value="1"> </el-option>
            <el-option label="附带代表队信息" :value="2"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="比赛地点" prop="address">
          <el-input v-model="adminform.address" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="竞赛规程" prop="competitionRules">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入竞赛规程"
            v-model="adminform.competitionRules"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdminFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdminForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogJoinMatchFormVisible">
      <el-form
        :model="joinForm"
        label-position="right"
        label-width="110px"
        :rules="joinFormRules"
        ref="joinForm"
      >
        <el-form-item label="比赛邀请码" prop="inviteCode">
          <el-input
            placeholder="请输入比赛邀请码"
            v-model="joinForm.inviteCode"
            @blur="searchMatch"
            maxlength="255"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchMatch"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="代表队" prop="teams">
          <el-select multiple v-model="joinForm.teams" style="width: 100%">
            <el-option
              v-for="item in teamOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛名称" prop="name">
          <el-input v-model="joinForm.name" disabled maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="主办单位" prop="host">
          <el-input v-model="joinForm.host" disabled maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="比赛时间" prop="dateRange">
          <el-date-picker
            disabled
            v-model="joinForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="比赛地点" prop="address">
          <el-input
            v-model="joinForm.address"
            disabled
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogJoinMatchFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="joinMatch" :loading="isLoading"
          >立即加入</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="'比赛授权'"
      :inline="true"
      :visible.sync="dialogHostAuthVisible"
    >
      <el-form
        :model="hostAuthForm"
        label-position="right"
        label-width="110px"
        :rules="hostAuthFormRules"
        ref="hostAuthForm"
      >
        <el-form-item label="主办方" prop="hostId">
          <el-select v-model="hostAuthForm.hostId">
            <el-option
              v-for="item in hostOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogHostAuthVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitHostAuthForm"
          :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="'文件上传'"
      :inline="true"
      :visible.sync="dialogRuleVisible"
    >
      <el-form
        :model="hostAuthForm"
        size="small"
        label-position="right"
        label-width="110px"
        :rules="formUploadRules"
        ref="hostAuthForm"
      >
        <el-form-item prop="workbook" label="附件类型">
          <el-select
            v-model="formUpload.attachmentType"
            @change="loadCurrentFile"
            placeholder="请选择附件类型"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="item in workbookOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="uploader">
          <el-upload
            ref="uploadRef"
            :http-request="uploadSecureFile"
            action=""
            :limit="1"
          >
            <el-button type="primary">点击上传文件</el-button>
            <template #tip>
              <div class="el-upload__tip">请选择赛程规则、组别文件。</div>
            </template>
          </el-upload>
        </el-form-item>
        <el-card class="box-card" v-if="currentFile != null">
          <div class="text item" v-for="itemFile in currentFile">
            <div style="display: flex; margin: 10px 0px">
              <div style="flex: 1; display: flex">
                <div style="width: 70%; align-items: center; display: flex">
                  {{ itemFile.name }}
                </div>
                <div style="align-items: center; display: flex">
                  {{ formatFileSize(itemFile.length) }}
                </div>
              </div>
              <div style="align-items: center; display: flex" title="删除附件">
                <i
                  class="el-icon-delete"
                  style="color: red"
                  @click="deleteFile(itemFile.id)"
                ></i>
              </div>
            </div>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRuleVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'文件下载'"
      :inline="true"
      :visible.sync="dialogRuleDownloadVisible"
    >
      <el-card class="box-card" v-if="currentFile != null">
        <div class="text item" v-for="itemFile in currentFile">
          <div style="display: flex; margin: 10px 0px">
            <div style="flex: 1; display: flex">
              <div style="width: 70%; align-items: center; display: flex">
                {{ itemFile.name }}
              </div>
              <div style="align-items: center; display: flex">
                {{ formatFileSize(itemFile.length) }}
              </div>
            </div>
            <div style="align-items: center; display: flex" title="下载附件">
              <i
                class="el-icon-download"
                @click="downloadRule(itemFile.id)"
              ></i>
            </div>
          </div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRuleDownloadVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../apis/match";
import moment from "moment";
import HostApi from "../apis/host";
import chart from "../views/PlayerChart";
import TeamApi from "../apis/team";
import APIAttach from "../apis/matchattachment";
import APIMC from "../apis/matchcategory";
export default {
  components: {
    chart,
  },
  data() {
    const teamValidate = function (rule, value, callback) {
      if (value.length === 0) {
        callback(new Error("请选择代表队"));
      } else {
        callback();
      }
    };
    return {
      workbookOptions: [
        { label: "赛程规则", value: 1 },
        { label: "赛程组别", value: 2 },
      ],
      categories: [],
      activeNames: "",
      isLoading: false,
      inputVisible: false,
      inputValue: "",
      dialogFormVisible: false,
      dialogEditFormVisible: false,
      dialogJoinMatchFormVisible: false,
      dialogAdminFormVisible: false,
      dialogHostAuthVisible: false,
      dialogRuleVisible: false,
      dialogRuleDownloadVisible: false,
      hostOptions: [],
      currentFile: [],
      multipleSelection: [],
      total: 0,
      uploading: false,
      tableListData: [],
      searchForm: {
        name: null,
        page: 1,
        pageSize: 15,
      },
      hostAuthForm: {
        hostId: null,
        matchId: null,
      },
      formUpload: {
        attachmentType: 1,
        matchId: 0,
      },
      formUploadRules: {
        attachmentType: [
          { required: true, message: "请选择附件类型", trigger: "blur" },
        ],
      },
      fileList: [],
      form: {
        confirmOrganizer: "",
        guidOrganizer: "",
        matchId: 0,
        name: "",
        organizer: "",
        host: "",
        hostMobile: "",
        coOrganizer: "",
        supportOrganizer: "",
        address: "",
        competitionRules: "",
        isIdentityValidate: true,
        isNeedIdentity: false,
        dateRange: [],
        isShowRebate: false,
        isShowTeamRebate: false,
        registrationEndTime: null,
        coverImage: null,
        competitionRuleFile: null,
      },
      adminform: {
        confirmOrganizer: "",
        guidOrganizer: "",
        competitionHostId: null,
        matchId: 0,
        name: "",
        organizer: "",
        supportOrganizer: "",
        host: "",
        hostMobile: "",
        coOrganizer: "",
        address: "",
        competitionRules: "",
        isIdentityValidate: true,
        isNeedIdentity: false,
        dateRange: [],
        isShowRebate: false,
        isShowTeamRebate: false,
        registrationEndTime: null,
        coverImage: null,
        competitionRuleFile: null,
      },
      joinForm: {
        inviteCode: null,
        teams: [],
        dateRange: [],
      },
      teamOptions: [],
      formRules: {
        name: [{ required: true, message: "请输入比赛名称", trigger: "blur" }],
        host: [{ required: true, message: "请输入主办方", trigger: "blur" }],
        address: [
          { required: true, message: "请输入比赛地址", trigger: "blur" },
        ],
        dateRange: [
          { required: true, message: "请输入比赛日期", trigger: "blur" },
        ],
      },
      hostAuthFormRules: {
        hostId: [{ required: true, message: "请输入主办方", trigger: "blur" }],
      },
      adminFormRules: {
        competitionHostId: [
          { required: true, message: "请选择主办方", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入比赛名称", trigger: "blur" }],
        host: [{ required: true, message: "请输入主办方", trigger: "blur" }],
        address: [
          { required: true, message: "请输入比赛地址", trigger: "blur" },
        ],
        dateRange: [
          { required: true, message: "请输入比赛日期", trigger: "blur" },
        ],
      },
      joinFormRules: {
        inviteCode: [
          { required: true, message: "请输入邀请码", trigger: "blur" },
        ],
        teams: [
          {
            required: true,
            message: "请选择代表队",
            trigger: "blur",
            validator: teamValidate,
          },
        ],
      },
    };
  },
  methods: {   
    deleteCategories(id) {
      let that = this;
      APIMC.delete({ id: id }).then((res) => {
        if (res.code == 0) {
          that.$message.success({
            showClose: true,
            message: "分类已经删除",
            duration: 2000,
          });
          that.loadMatchMusicList(this.form.matchId);
        } else {
          that.$message.error({
            showClose: true,
            message: res.message,
            duration: 2000,
          });
        }
      });
    },
    deleteMusic(id) {
      let that = this;
      APIMC.deleteMusic({ id: id }).then((res) => {
        if (res.code == 0) {
          that.$message.success({
            showClose: true,
            message: "音乐已经删除",
            duration: 2000,
          });
          that.loadMatchMusicList(this.form.matchId);
        } else {
          that.$message.error({
            showClose: true,
            message: res.message,
            duration: 2000,
          });
        }
      });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      let that = this;
      if (inputValue) {
        APIMC.add({ name: inputValue, matchId: this.form.matchId }).then(
          (res) => {
            if (res.code == 0) {
              that.$message.success({
                showClose: true,
                message: "舞蹈分类创建成功",
                duration: 2000,
              });
              this.loadMatchMusicList(this.form.matchId);
            } else {
              that.$message.error({
                showClose: true,
                message: res.message,
                duration: 2000,
              });
            }
          }
        );
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    loadMatchMusicList(id) {
      API.loadCategory({ matchId: id }).then((res) => {
        this.categories = res.result;
      });
    },
    uploadMusicFile(param, matchId, categoryid) {
      let that = this;
      this.isLoading = true;
      var fileObj = param.file;
      var formData = new FormData();
      formData.append("file", fileObj);
      formData.append("CategoryId", categoryid);
      formData.append("MatchId", matchId);
      APIAttach.uploadMusic(formData)
        .then((res) => {
          that.isLoading = false;
          if (res.code == 0) {
            that.$message.success({
              showClose: true,
              message: "音乐上传成功",
              duration: 2000,
            });
            that.loadMatchMusicList(matchId);
          } else {
            that.$message.error({
              showClose: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.isLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    downloadRule(id) {
      APIAttach.downloadFile({ id: id }).then((res) => {
        var content = res.data;
        if (content.type == "application/json") {
          this.$message.error({
            showClose: true,
            message: "未找到文件附件，或还未上传",
            duration: 2000,
          });
        } else {
          var blob = new Blob([content], { type: res.type });
          var fileName = decodeURIComponent(res.headers["filename"]);
          if ("download" in document.createElement("a")) {
            var elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
    },
    deleteFile(id) {
      this.$confirm("确认删除该文件附件吗？", "提示", { type: "warning" })
        .then(() => {
          APIAttach.del({ id: id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.currentFile = null;
              } else {
                this.$message.error({
                  showClose: true,
                  message: res.message,
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "系统错误",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    formatFileSize(size) {
      if (size < 1024 * 1024) {
        const temp = size / 1024;
        return temp.toFixed(2) + "KB";
      } else if (size < 1024 * 1024 * 1024) {
        const temp = size / (1024 * 1024);
        return temp.toFixed(2) + "MB";
      } else {
        const temp = size / (1024 * 1024 * 1024);
        return temp.toFixed(2) + "GB";
      }
    },
    showUploadDialog(matchId) {
      this.dialogRuleVisible = true;
      this.formUpload.matchId = matchId;
      this.loadCurrentFile();
    },
    showDownloadDialog(matchId, type) {
      this.dialogRuleDownloadVisible = true;
      this.formUpload.matchId = matchId;
      this.formUpload.attachmentType = type;
      this.loadCurrentFile();
    },
    uploadSecureFile(param) {
      let that = this;
      this.isLoading = true;
      var fileObj = param.file;
      var formData = new FormData();
      formData.append("file", fileObj);
      formData.append("AttachmentType", that.formUpload.attachmentType);
      formData.append("MatchId", that.formUpload.matchId);
      APIAttach.upload(formData)
        .then((res) => {
          if (res.code == 0) {
            that.$message.success({
              showClose: true,
              message: "附件上传成功",
              duration: 2000,
            });
            that.$refs.uploadRef.clearFiles();
            this.loadCurrentFile();
          } else {
            that.$message.error({
              showClose: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    loadCurrentFile() {
      APIAttach.list(this.formUpload).then((res) => {
        this.currentFile = res.result;
      });
    },
    gotoRule(matchId) {
      APIAttach.download({ matchId: matchId, attachmentType: 1 }).then(
        (res) => {
          var content = res.data;
          if (content.type == "application/json") {
            this.$message.error({
              showClose: true,
              message: "未找到文件附件，或还未上传",
              duration: 2000,
            });
          } else {
            var blob = new Blob([content], { type: res.type });
            var fileName = decodeURIComponent(res.headers["filename"]);
            if ("download" in document.createElement("a")) {
              var elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            } else {
              navigator.msSaveBlob(blob, fileName);
            }
          }
        }
      );
    },
    gotoRule1(matchId) {
      APIAttach.download({ matchId: matchId, attachmentType: 2 }).then(
        (res) => {
          var content = res.data;
          if (content.type == "application/json") {
            this.$message.error({
              showClose: true,
              message: "未找到文件附件，或还未上传",
              duration: 2000,
            });
          } else {
            var blob = new Blob([content], { type: res.type });
            var fileName = decodeURIComponent(res.headers["filename"]);
            if ("download" in document.createElement("a")) {
              var elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            } else {
              navigator.msSaveBlob(blob, fileName);
            }
          }
        }
      );
    },
    handleRuleRemove(file, fileList) {
      this.form.competitionRuleFile = null;
    },
    handleAdminRuleRemove(file, fileList) {
      this.adminform.competitionRuleFile = null;
    },
    handleRemove(file, fileList) {
      this.form.coverImage = null;
    },
    handleAdminRemove(file, fileList) {
      this.adminform.coverImage = null;
    },
    uploadEditFile(param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.form.coverImage =
              "https://bm.lwdance.top/api" + result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    uploadRuleFile(param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.form.competitionRuleFile =
              "https://bm.lwdance.top/api" + result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    uploadAdminEditFile(param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.adminform.coverImage =
              "https://bm.lwdance.top/api" + result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    uploadAdminRuleFile(param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.adminform.competitionRuleFile =
              "https://bm.lwdance.top/api" + result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },

    authHost() {
      let val = this.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].matchId);
      }
      if (idArray.length < 1) {
        this.$message.error({
          showClose: true,
          message: "请选择比赛",
          duration: 2000,
        });
        return;
      }
      this.dialogHostAuthVisible = true;
      this.$nextTick(() => {
        this.$refs["hostAuthForm"].resetFields();
        this.hostAuthForm.matchId = idArray;
      });
    },
    submitHostAuthForm() {
      this.isLoading = true;
      this.$refs.hostAuthForm.validate((valid) => {
        if (valid) {
          API.authHost(this.hostAuthForm)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "授权比赛成功",
                  duration: 2000,
                });
                this.dialogHostAuthVisible = false;
                this.search();
                this.isLoading = false;
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    isHostOrAdmin() {
      return (
        sessionStorage.getItem("userType") == "3" ||
        sessionStorage.getItem("userType") == "1"
      );
    },
    joinNewMatch() {
      this.dialogJoinMatchFormVisible = true;
      this.$nextTick(() => {
        this.$refs["joinForm"].resetFields();
        if (this.teamOptions != null && this.teamOptions.length == 1) {
          this.joinForm.teams = [this.teamOptions[0].value];
        }
      });
    },
    gotoMatch(row) {
      this.$router.push({
        path: "/matchdetail",
        query: { matchId: row.matchId },
      });
    },
    gotoRule(row) {
      this.$router.push({
        path: "/rule",
      });
    },
    gotoRule1(row) {
      this.$router.push({
        path: "/rule1",
      });
    },
    startTimeFormatter: function (row, column) {
      var date = row.startTime;
      if (date == undefined) {
        return "";
      }
      var enddate = row.endTime;
      if (enddate == undefined) {
        return "";
      }
      return (
        moment(date).format("YYYY-MM-DD") +
        "至" +
        moment(enddate).format("YYYY-MM-DD")
      );
    },
    endTimeFormat: function (row, column) {
      var date = row.endTime;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    editMatch(row) {
      this.formTitle = "编辑客户";
      API.get({ id: row.matchId }).then((result) => {
        this.form = Object.assign({}, result.result);
        this.$set(this.form, "dateRange", [
          this.form.startTime,
          this.form.endTime,
        ]);
        if (
          this.form.competitionRuleFile != null &&
          this.form.competitionRuleFile != ""
        ) {
          this.fileList = [
            { url: this.form.competitionRuleFile, name: "赛程规则" },
          ];
        } else {
          this.fileList = [];
        }
        this.loadMatchMusicList(row.matchId);
        this.dialogEditFormVisible = true;
      });
    },
    //新增部门表单弹框
    addMatch() {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    addAdminMatch() {
      this.dialogAdminFormVisible = true;
      this.$nextTick(() => {
        this.$refs["adminform"].resetFields();
      });
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    searchMatch() {
      if (
        this.joinForm.inviteCode == "" ||
        this.joinForm.inviteCode.length < 5
      ) {
        this.$message.error({
          showClose: true,
          message: "请输入邀请码",
          duration: 2000,
        });
        return;
      }
      let params = {
        inviteCode: this.joinForm.inviteCode,
      };
      API.searchMatch(params)
        .then((result) => {
          if (result && result.code == 0) {
            var matchInfo = result.result;
            this.joinForm.name = matchInfo.name;
            this.joinForm.host = matchInfo.host;
            this.joinForm.address = matchInfo.address;
            this.joinForm.dateRange = [matchInfo.startTime, matchInfo.endTime];
          } else {
            this.$message.error({
              showClose: true,
              message: result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    joinMatch() {
      this.isLoading = true;
      this.$refs.joinForm.validate((valid) => {
        if (valid) {
          let params = {
            inviteCode: this.joinForm.inviteCode,
            teams: this.joinForm.teams,
          };
          API.joinMatch(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "加入比赛成功",
                  duration: 2000,
                });
                this.$refs["joinForm"].resetFields();
                this.dialogJoinMatchFormVisible = false;
                this.search();
                this.isLoading = false;
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (this.form.dateRange != null && this.form.dateRange.length > 1) {
            params.startTime = this.form.dateRange[0];
            params.endTime = this.form.dateRange[1];
          }
          if (params.matchId > 0) {
            API.edit(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "更改成功",
                      duration: 2000,
                    });
                    that.dialogFormVisible = false;
                    that.$refs["form"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: "更新失败",
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.add(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 2000,
                  });
                  this.$refs["form"].resetFields();
                  this.dialogFormVisible = false;
                  this.search();
                  this.isLoading = false;
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "新增失败",
                    duration: 2000,
                  });
                  this.isLoading = false;
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "请求异常",
                  duration: 2000,
                });
                this.isLoading = false;
              });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    submitEditForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (this.form.dateRange != null && this.form.dateRange.length > 1) {
            params.startTime = this.form.dateRange[0];
            params.endTime = this.form.dateRange[1];
          }
          API.edit(params)
            .then(
              (data) => {
                if (data.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "更改成功",
                    duration: 2000,
                  });
                  that.dialogEditFormVisible = false;
                  that.$refs["form"].resetFields();
                  that.search();
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "更新失败",
                    duration: 2000,
                  });
                }
                that.isLoading = false;
              },
              function (err) {
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
                that.isLoading = false;
              }
            )
            .catch(function (error) {
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
              that.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    submitAdminForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.adminform.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.adminform);
          if (
            this.adminform.dateRange != null &&
            this.adminform.dateRange.length > 1
          ) {
            params.startTime = this.adminform.dateRange[0];
            params.endTime = this.adminform.dateRange[1];
          }
          API.adminAdd(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "新增成功",
                  duration: 2000,
                });
                this.$refs["adminform"].resetFields();
                this.dialogAdminFormVisible = false;
                this.search();
                this.isLoading = false;
              } else {
                this.$message.error({
                  showClose: true,
                  message: "新增失败",
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    deleteMatch(row) {
      let params = { id: row.matchId };
      this.$confirm("确认删除记录吗？", "提示", { type: "warning" })
        .then(() => {
          API.delete(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.search();
              } else {
                this.$message.error({
                  showClose: true,
                  message: "系统错误",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "123",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].matchId);
      }
      this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "删除操作异常，请重试",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
  },
  computed: {},
  mounted() {
    this.search();
    HostApi.select().then((res) => {
      this.hostOptions = res.result;
    });
    TeamApi.select().then((res) => {
      this.teamOptions = res.result;
    });
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/*/deep/ .match-title .el-link--inner{
  white-space: break-spaces;
}*/
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.wrap-text {
  white-space: pre-line !important;
  word-wrap: break-word;
}
.el-table .cell{
  white-space: pre-line !important;
}
/* 用于处理长单词或 URL 的换行 */
.break-word {
  word-break: break-all;
  overflow-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/views/Match.vue